import { Cf7FormData } from "./types";

export async function sendCf7Form(data: Cf7FormData) {
  const endpoint = process.env.NEXT_PUBLIC_CF7_ENDPOINT;
  const formId = process.env.NEXT_PUBLIC_CF7_FORM_ID;
  const version = process.env.NEXT_PUBLIC_CF7_VERSION;
  const locale = process.env.NEXT_PUBLIC_CF7_LOCALE;
  const unitTag = process.env.NEXT_PUBLIC_CF7_UNIT_TAG;
  const containerPost = process.env.NEXT_PUBLIC_CF7_CONTAINER_POST;

  if (
    !endpoint ||
    !formId ||
    !version ||
    !locale ||
    !unitTag ||
    !containerPost
  ) {
    throw new Error(
      "One or more required environment variables are not defined."
    );
  }

  const dataToSend = new FormData();
  dataToSend.append("_wpcf7", formId);
  dataToSend.append("_wpcf7_version", version);
  dataToSend.append("_wpcf7_locale", locale);
  dataToSend.append("_wpcf7_unit_tag", unitTag);
  dataToSend.append("_wpcf7_container_post", containerPost);
  dataToSend.append("first-name", data.firstName);
  dataToSend.append("last-name", data.lastName);
  dataToSend.append("your-email", data.email);
  dataToSend.append("your-message", data.message);
  dataToSend.append("your-name", `${data.firstName} ${data.lastName}`);
  dataToSend.append("your-subject", data.subject || "Contact Us Message");

  const response = await fetch(endpoint, {
    method: "POST",
    body: dataToSend,
  });

  if (!response.ok) {
    throw new Error(`HTTP error: ${response.status}`);
  }

  return response.json();
}
